{
  "WALLBOARD": {
    "LOADING": "Зареждане на телефонни опашки...",
    "NO_QUEUES": "Не са намерени телефонни опашки.",
    "AGENTS": "Оператори",
    "NO_AGENTS": "Няма онлайн оператори в тази опашка.",
    "NO_AGENTS_ONLINE": "Няма онлайн оператори.",
    "WAITING_CALLERS": "Чакащи обаждащи се",
    "NO_CALLERS": "Няма чакащи обаждащи се.",
    "UNKNOWN_CALLER": "Непознат обаждащ се",
    "POSITION": "Позиция",
    "STATUS": "Статус",
    "TIME": "Време",
    "AGENT": "Оператор",
    "EXTENSION": "Разширение",
    "AVAILABLE": "На разположение",
    "READY": "Готови оператори",
    "ON_CALL": "Оператори на разговор",
    "QUEUE_CALL": "Обаждане от опашка",
    "OTHER_CALL": "Друго обаждане",
    "PAUSED": "Оператори в почивка",
    "WAITING": "Чакащи обаждания",
    "MISSED_CALLS": "Пропуснати обаждания",
    "HANDLED_CALLS": "Обработени входящи обаждания",
    "OUTBOUND_CALLS": "Обработени изходящи обаждания",
    "AVAILABILITY": "Достъпност",
    "AVAILABILITY_TOOLTIP": "Процент на входящите обаждания, които операторите са приели (обаждания, които са били вдигнати)",
    "TOTAL": "общо",
    "AGENTS_COUNT": "({onCall} на разговор / {total} общо)",
    "NO_AVAILABLE": "(никой не е онлайн)",
    "WAITING_CALLERS_COUNT": "{count} чакащи",
    "CALLER": "Обаждащ се",
    "NUMBER": "Номер",
    "WAIT_TIME": "Време на изчакване",
    "QUEUES": "Опашки",
    "ACTION": "Действие",
    "PICKUP_CALL": "Вдигни",
    "PICKING_UP": "Вдигане...",
    "PICKUP_SUCCESS": "Заявката за вдигане на обаждане е успешна.",
    "PICKUP_ERROR": "Неуспешно вдигане на обаждането. Моля, опитайте отново.",
    "PICKUP_DISABLED_TOOLTIP": "Не можете да вдигнете обаждане, когато сте на разговор или офлайн.",
    "CHAT_STATUS": {
      "NO_ACCESS": "Няма достъп"
    },
    "PHONE_STATUS": {
      "NO_ACCESS": "Няма достъп"
    }
  }
}
